const years = 10;

function calculateFutureValue({ rate, periods, payment, value = 0, type = 0 }) {
    let result = 0;

    if (rate === 0) {
        result = value + payment * periods;
    } else {
        const term = (1 + rate) ** periods;

        if (type === 1) {
            result = value * term + (payment * (1 + rate) * (term - 1)) / rate;
        } else {
            result = value * term + (payment * (term - 1)) / rate;
        }
    }
    return -result;
}

function calculatePortfolioValues({ stateofMarket, totalRetirementSavings, withdrawalAmount, withdrawalFrequency }) {
    const allStatesOfMarketRatesOfReturn = {
        badStart: [-16, -6, 7, 10, 9, 11, -5, 4, 16, 24],
        goodStart: [24, 16, 4, -5, 11, 9, 10, 7, -6, -16],
        stableReturn: [4.8, 4.8, 4.8, 4.8, 4.8, 4.8, 4.8, 4.8, 4.8, 4.8],
    };
    const ratesOfReturn = allStatesOfMarketRatesOfReturn[stateofMarket];
    let portfolioValues = [{ year: 0, portfolioValue: totalRetirementSavings }];

    for (let i = 0; i < years; i++) {
        const rateOfReturn = (1 + ratesOfReturn[i] / 100) ** (1 / withdrawalFrequency) - 1;
        const previousPortfolioValue = portfolioValues.slice(-1)[0].portfolioValue;
        const portfolioValue = Math.max(
            calculateFutureValue({
                rate: rateOfReturn,
                periods: withdrawalFrequency,
                payment: withdrawalAmount,
                value: -previousPortfolioValue,
                type: 1,
            }),
            0,
        );

        portfolioValues = portfolioValues.concat({
            year: i + 1,
            portfolioValue,
        });

        if (i + 1 === years) {
            portfolioValues[i + 1].lastYear = true;
        }
    }
    return portfolioValues;
}

function calculateResults({ totalRetirementSavings, withdrawalAmount, withdrawalFrequency }) {
    const badStartPortfolioValues = calculatePortfolioValues({
        stateofMarket: "badStart",
        totalRetirementSavings,
        withdrawalAmount,
        withdrawalFrequency,
    });
    const goodStartPortfolioValues = calculatePortfolioValues({
        stateofMarket: "goodStart",
        totalRetirementSavings,
        withdrawalAmount,
        withdrawalFrequency,
    });
    const stableReturnPortfolioValues = calculatePortfolioValues({
        stateofMarket: "stableReturn",
        totalRetirementSavings,
        withdrawalAmount,
        withdrawalFrequency,
    });

    if (withdrawalAmount <= 0) {
        const { portfolioValue: goodStartFinalPortfolioValue } = goodStartPortfolioValues.slice(-1)[0];
        stableReturnPortfolioValues[years].portfolioValue = goodStartFinalPortfolioValue;
    }

    return {
        badStart: badStartPortfolioValues,
        goodStart: goodStartPortfolioValues,
        stableReturn: stableReturnPortfolioValues,
    };
}

export { calculateResults };
